import { AuthByPhone } from '@/features/auth/by-phone'

import { sendYandexMetricaEvent } from '@/shared/integrations/yandex-metric/utils/send-metric-event'

import cl from './Authorization.module.scss'

interface AuthorizationProps {
	onSuccess?: () => void
}

export const Authorization = (props: AuthorizationProps) => {
	const { onSuccess } = props

	const onSuccessAuth = () => {
		onSuccess()
		sendYandexMetricaEvent(`auth_success`)
	}

	return (
		<div className={cl.root}>
			<div className={cl.content}>
				<AuthByPhone onSuccess={onSuccessAuth} />
			</div>
		</div>
	)
}
